import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {BaseComponent} from '../../../components/BaseComponent';
import {Button} from '../../../components/Buttons';
import {Modal, ModalControls} from '../../../components/Modal';

const STATE = {
};

/* eslint-disable react/prefer-stateless-function */
class BpmWarningModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get invoice() {
    return this.props.invoice;
  }


  applySelection() {
    this.props.addInvoiceRelation(this.state.selectedInvoice.id, this.reset.bind(this));
  }

  get modalMsg() {
    return  (
      <p>{this.lbl(`invoice.details.bpmWarning`)}</p>
    );

  }

  get disableApplyBtn() {
    return !(this.correctProtectMessage === this.state.protectMessage);
  }

  onConfirm() {
    this.props.onConfirm();
  }

  onCancel() {
    this.props.onCancel();
  }

  render() {
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl(`invoice.details.warning`)}>
        {this.modalMsg}
        <ModalControls>
          <Button onClick={this.onConfirm.bind(this)} primary disabled={this.disableApplyBtn}>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.onCancel.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
  );
  }
}

BpmWarningModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BpmWarningModal = compose(
  withConnect,
  withRouter,
)(BpmWarningModalComp);
